/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable default-param-last */
/* eslint-disable radix */
import React from "react";
import * as ReactDOMServer from "react-dom/server";
import L from "leaflet";
import dayjs from "dayjs";
import SnapToRoadIcon from "../Common/Svgs/SnapToRoadIcon";
import { TRIP_STATUS } from "../Modules/Trips/Data/TripConstants";

const getTripPointsOnMap = (
  stopNumber,
  totalLength,
  status = 1,
  lastVisitedStop,
  recordedTime,
) => {
  const isHomeMarker = stopNumber === 0 || stopNumber === totalLength - 1;

  const isUpcoming = status === TRIP_STATUS.UPCOMING;

  const isCompleted = status === TRIP_STATUS.COMPLETED;

  const isVisited =
    isCompleted ||
    (status === TRIP_STATUS.ONGOING && stopNumber <= lastVisitedStop);

  // for intermediate stops
  const markerFill = isVisited ? "#085054" : "#DFDFDF";
  const markerStroke = isVisited ? "#085054" : "#525252";

  // for first and last stops
  const homeMarkerBg = isUpcoming ? "#DFDFDF" : "#085054";
  const homeMarkerBorder = isUpcoming ? "#525252" : "#085054";
  const homeIconColor = isUpcoming ? "#525252" : "#085054";

  // eslint-disable-next-line new-cap
  return new L.divIcon({
    html: ReactDOMServer.renderToString(
      <div className="relative group -mt-[45px] -ml-[15px]">
        {isHomeMarker ? (
          <svg
            width="36"
            height="60"
            viewBox="0 0 36 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* Bottom pointer */}
            <path d="M12 34L18 46L24 34H12Z" fill={homeMarkerBorder} />
            {/* Route endpoint circle */}
            <circle
              cx="18"
              cy="48"
              r="4"
              fill="#FCFCFC"
              stroke={homeIconColor}
              strokeWidth="3"
            />
            <circle
              cx="18"
              cy="18"
              r="16"
              fill={homeMarkerBg}
              stroke={homeMarkerBorder}
              strokeWidth="4"
            />

            <rect
              x="2"
              y="2"
              width="32"
              height="32"
              rx="16"
              fill={homeMarkerBg}
            />
            <path
              d="M17.4111 23V13.304H15.9231V11.64H19.2511V23H17.4111Z"
              fill="#FAD152"
            />

            <rect x="2" y="2" width="32" height="32" rx="16" fill="#FCFCFC" />
            <path
              d="M11.332 24.6665H24.6654"
              stroke={homeIconColor}
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.9648 24.6665L11.9982 16.6465C11.9982 16.2398 12.1915 15.8532 12.5115 15.5999L17.1782 11.9665C17.6582 11.5932 18.3315 11.5932 18.8182 11.9665L23.4848 15.5932C23.8115 15.8465 23.9982 16.2332 23.9982 16.6465V24.6665M22.6648 14.6665L22.6448 12.6665H19.7115M18.6649 21.3332H17.3315C16.7782 21.3332 16.3315 21.7798 16.3315 22.3332V24.6665H19.6649V22.3332C19.6649 21.7798 19.2182 21.3332 18.6649 21.3332Z"
              stroke={homeIconColor}
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          <svg
            width="36"
            height="46"
            viewBox="0 0 36 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M12 34L18 46L24 34H12Z" fill={markerStroke} />

            <circle
              cx="18"
              cy="18"
              r="16"
              fill={markerFill}
              stroke={markerStroke}
              strokeWidth="3"
            />

            <rect
              x="2"
              y="2"
              width="32"
              height="32"
              rx="16"
              fill={markerFill}
            />
            <div
              className={`absolute top-0 left-0 w-[36px] h-[36px] flex items-center justify-center font-medium font-poppins text-base ${
                isVisited ? "text-[#FAD152]" : "text-dark-gray"
              }`}
            >
              {stopNumber}
            </div>
          </svg>
        )}
        {/* tooltip for visited stops */}
        {isVisited && !isUpcoming && (
          <div className="absolute left-[22px] top-[10px] hidden group-hover:block z-[9999]">
            <svg width="83" height="44" viewBox="0 0 83 44" fill="none">
              <path
                d="M20.5147 16.0711C20.5147 16.962 19.4376 17.4081 18.8076 16.7782L12.7365 10.7071C12.346 10.3166 12.346 9.68342 12.7365 9.29289L18.8076 3.22183C19.4376 2.59187 20.5147 3.03803 20.5147 3.92894L20.5147 16.0711Z"
                fill="#525252"
              />

              <rect x="18" width="53" height="20" rx="4" fill="#525252" />

              <text
                x="45"
                y="13"
                fill="#F8F6F4"
                fontSize="10"
                fontFamily="Poppins"
                textAnchor="middle"
              >
                {recordedTime ? dayjs(recordedTime).format("hh:mm A") : "-"}
              </text>
            </svg>
          </div>
        )}
      </div>,
    ),
  });
};

export const getSnapToRoadPointsOnMap = () => {
  // eslint-disable-next-line new-cap
  return new L.divIcon({
    html: ReactDOMServer.renderToString(
      <div className="absolute z-10 w-3 h-3 top-[-6px] left-[-4px]">
        <SnapToRoadIcon size={24} className="text-black" />
      </div>,
    ),
  });
};

export default getTripPointsOnMap;
